import { render, staticRenderFns } from "./ToDoNotesIconSection.vue?vue&type=template&id=88a90584"
import script from "./ToDoNotesIconSection.vue?vue&type=script&lang=js"
export * from "./ToDoNotesIconSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports